import { object, string, StringSchema } from "yup";
import { iField } from "/app/src/models";
import i18next from "/app/src/locales/config";

/**
 * Creates a schema for manually entering an order based on provided fields.
 * @param orderFields - Array of field definitions used to build the schema.
 * @returns A Yup object schema configured with required validations.
 */
export const createManualOrderSchema = (orderFields: iField[]) => {
  return object().shape({
    name: string().required(i18next.t("translation:required")),
    directionType: string().required(i18next.t("translation:required")),
    statusId: string().required(i18next.t("translation:required")),
    shelves: string().when("directionType", {
      is: "Replenishment",
      then: (schema) => schema.required(i18next.t("translation:required")),
      otherwise: (schema) => schema.notRequired(),
    }),
    ...orderFields
      .filter((field: iField) => field.name !== "name")
      .reduce<{ [key: string]: StringSchema }>(
        (acc, field: iField) => ({
          ...acc,
          [field.name]: string().when({
            is: () => field.required,
            then: (schema) =>
              schema.required(i18next.t("translation:required")),
            otherwise: (schema) => schema.notRequired(),
          }),
        }),
        {},
      ),
  });
};
